import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100vh"
          image={`url(${mobileHero}) bottom/ cover no-repeat`}
          column
          alignCenter
        >
          <Header />
          <CFView column center textCenter w="100%">
            <CFView xBold style={{ fontSize: 40 }} mt="15px" color="white">
              NOW TAKING
            </CFView>
            <CFView xBold style={{ fontSize: 40 }} mt="10px" color="#D40F33">
              ONLINE ORDERS
            </CFView>
            <CFView pulsate mt="30px">
              <OrderPickupButton />
            </CFView>
            <CFView mt="10px">
              <OrderDeliveryButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="700px"
          w="100%"
          image={`url(${hero}) top/ cover no-repeat`}
          zIndex={90}
          column
          justifyCenter
          alignStart
        >
          <Header />
          <CFView column justifyCenter alignStart ml="105px">
            <CFImage
              w="450px"
              src={heroText}
              alt="Sushi Karis Korean Restaurant hero text"
              zIndex={98}
            />
            <CFView pulsate mt="50px">
              <OrderPickupButton />
            </CFView>
            <CFView mt="15px">
              <OrderDeliveryButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
